import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

// Start a calling session from a bulk selection and open it.
export const startCallingFrom = async ({ headers, navigate, source, ids, picked }) => {
  try {
    const body = source === 'esign' ? { source, esign_ids: ids } : { source, segment: 'all', application_ids: ids };
    const { data } = await axios.post(`${API}/api/calling/sessions`, body, { headers });
    if (data.total < picked) toast.message(`${data.total} of ${picked} can be called — the rest are closed or have nobody left to sign`);
    navigate(`/calling?session=${data.id}`);
  } catch (e) {
    toast.error(e.response?.data?.detail || 'Could not start calling');
  }
};
